export default __webpack_public_path__ + "static/media/uv11_en_head_a1.40c63966.mp3";